import { plural, getNearestUpperMultiple, keepValueInRange } from '@cian/utils';

import { trackAuctionIncreaseModalShow } from './modal-auction-increase.tracking';

export default [
  '$scope',
  'settings',
  '$uibModalInstance',
  'auctionApi',
  'placingTermsApi',
  'deviceService',
  function ($scope, settings, $uibModalInstance, auctionApi, placingTermsApi, deviceService) {
    $scope.isMobile = deviceService.isMobile;

    const {
      /** Текущая позиция в выдаче */
      currentPosition,
      currentBet,
      recommendedBet,
      betStep,
      betServiceConcurrency,
      /** Выбранный VAS на форму выбора услуг */
      option,
    } = settings;
    const { auctionMinBet, auctionMaxBet } = placingTermsApi;

    // $scope.isPenetratingConcurrencyEnabled = isPenetratingConcurrencyEnabled;
    $scope.option = option;
    $scope.auctionMaxBet = auctionMaxBet;
    $scope.auctionBetMaxLength = String(auctionMaxBet).length;

    const auctionBetValidate = () => placingTermsApi.auctionBetValidate(this.auctionBet, betStep, true);

    $scope.isAuctionBetInvalid = auctionBetValidate;

    const getAuctionBetErrorText = () => {
      const error = auctionBetValidate();

      if (!error) {
        return;
      }

      const ERROR_TEXTS = {
        min: `Минимальная ставка — ${auctionMinBet} ₽`,
        max: `Максимальная ставка — ${auctionMaxBet} ₽`,
        multiple: `Ставка должна быть кратна ${betStep} рублям.`,
      };

      return ERROR_TEXTS[error];
    };
    $scope.getAuctionBetErrorText = getAuctionBetErrorText;

    const SERVICE_IDS_MAP = {
      paid: 'paid',
      premium: 'premium',
      'premium+highlight': 'premium',
      top3: 'top3',
    };

    const SERVICE_NAMES_MAP = {
      paid: plural(betServiceConcurrency, ['Платное', 'Платных', 'Платных']),
      premium: 'Премиум',
      top3: 'Топ',
    };

    const SIMPLE_SERVICE_NAMES_MAP = {
      paid: 'Платных',
      premium: 'Премиум',
      top3: 'Топ',
    };

    const serviceName = SERVICE_NAMES_MAP[SERVICE_IDS_MAP[option.id]];

    $scope.simpleServiceName = SIMPLE_SERVICE_NAMES_MAP[SERVICE_IDS_MAP[option.id]];

    $scope.pluralizeServiceName = count => {
      const SERVICE_NAMES_MAP = {
        paid: plural(count, ['Платное', 'Платных', 'Платных']),
        premium: 'Премиум',
        top3: 'Топ',
      };

      return SERVICE_NAMES_MAP[SERVICE_IDS_MAP[option.id]];
    };

    $scope.getAuctionIncreaseModalTitle = () => {
      if ($scope.isPenetratingConcurrencyEnabled()) {
        return (
          `${currentPosition} ${serviceName.toLowerCase()} ${plural(currentPosition, [
            'объявление',
            'объявления',
            'объявлений',
          ])}` +
          ' выше вас в поиске.\n' +
          'Повысьте ставку, чтобы опередить их!'
        );
      }

      return (
        `${currentPosition} ${plural(currentPosition, ['пользователь', 'пользователя', 'пользователей'])}` +
        ' выше вас в поиске.\n' +
        'Повысьте ставку, чтобы опередить их!'
      );
    };
    $scope.title =
      `${currentPosition} ${plural(currentPosition, ['пользователь', 'пользователя', 'пользователей'])}` +
      ' выше вас в поиске.\n' +
      'Повысьте ставку, чтобы опередить их!';

    $scope.currentBet = currentBet;
    this.auctionBet = recommendedBet;

    const getPositionForecast = () => {
      $scope.isFetching = true;
      $scope.isSuccess = false;

      auctionApi
        .getBetPositionForecast(this.auctionBet)
        .then(({ data }) => {
          $scope.isFetching = false;
          $scope.isSuccess = true;
          $scope.betFullConcurrency = data.betFullConcurrency;
          $scope.betServiceConcurrency = data.betServiceConcurrency;
          $scope.positionForecast = data.increaseBetsPositionsCount;
        })
        .catch(() => {
          $scope.isFetching = false;
        });
    };

    $scope.isPenetratingConcurrencyEnabled = () => {
      return Number.isFinite($scope.betFullConcurrency) && Number.isFinite($scope.betServiceConcurrency);
    };

    $scope.confirm = () => $uibModalInstance.close(this.auctionBet);
    $scope.isBetValid = () => {
      /* Валидация кратности ставки шагу ставки */
      const isMultiplierValid = this.auctionBet % betStep === 0;

      return this.auctionBet >= currentBet && isMultiplierValid;
    };

    $scope.increaseBet = () => {
      const { auctionMinBet, auctionMaxBet } = placingTermsApi;

      this.auctionBet = keepValueInRange(
        getNearestUpperMultiple(this.auctionBet + 1, betStep || 1),
        auctionMinBet,
        auctionMaxBet,
      );

      getPositionForecast();
    };

    $scope.handleBetChange = getPositionForecast;

    getPositionForecast();

    trackAuctionIncreaseModalShow();
  },
];
